import loadAsset from './modules/load-asset';
import { lazy } from './modules/lazy-load';
import findPosition from './modules/find-position';
import initSpliders from './modules/initSplideSliders';
const theme = '/wp-content/themes/orbis';
const v = document.querySelector('[data-version]').getAttribute('data-version');
console.log(v);

let position = findPosition();

//initialize lazy load of images 
lazy.init('[data-src]', 5000); 

//load fonts
loadAsset('https://use.typekit.net/tvy4tkj.css', 'link');

//check for buttons that need to trigger a distinct action of client selection
const triggers = document.querySelectorAll('[data-clickAction]');
if( triggers.length > 0 ) { //none found, don't worry about it
    let actions = {}; //an object to hold our defined functions

    triggers.forEach( trigger => { //foreach of the buttons/triggers, add an event listener
        trigger.addEventListener( 'click', e => {
            e.preventDefault();
            e.stopImmediatePropagation();
            const action = trigger.getAttribute('data-clickAction'); //each trigger should have a clickAction
            if( actions.hasOwnProperty( action ) ) { //if that value matches a defined function...
                actions[action](); //call that defined function.
            }
        } )
    } )

    // add constant elements
    const form = document.querySelector('[data-request-form]');
    const overlay = document.querySelector('[data-overlay]');

    // add Functions
    actions['open-form'] = () => { 
        showForm( 'request' );
        form.classList.toggle('active');
        overlay.classList.toggle('active');
    }
    
    actions['open-info-form'] = () => { 
        showForm( 'info' );
        form.classList.toggle('active');
        overlay.classList.toggle('active');
    }

    actions['close-form'] = (e) => {
        if ( overlay.classList.contains('active') ) {
            form.classList.toggle('active');
            overlay.classList.toggle('active');
        } else { return }
    }

    //Need to make this work for request form AND info form, should have two actions, single function to open form drawer – param by name
}

function showForm( formName ) {
    const forms = document.querySelectorAll('[data-gravity-form]');
    forms.forEach( thisForm => {
        thisForm.classList.remove('show');
    })
    document.querySelector(`[data-gravity-form=${formName}]`).classList.add('show');
}

const limitedHeight = document.querySelectorAll( '[data-height-limit]' );
if( limitedHeight ) {
    limitedHeight.forEach( container => {
        const contentHeight = container.scrollHeight;
        const containerHeight = container.clientHeight;
        const button = document.querySelector( `[data-height-limit-target=${ container.getAttribute('id') }]` );
        if( contentHeight <= containerHeight ) {
            button.style.display = 'none';
        } 
    })
}

const interest = document.querySelector('[data-product-interest]');
if( interest ) {
    const detail = interest.getAttribute('data-product-interest');
    if( detail && detail.length > 0 ) {
        let interestField = document.querySelector('.product-of-interest input');
        if ( interestField ) {
            interestField.value = detail;
        }
    }
    
}

const carousels = [...document.querySelectorAll('[data-carousel]')];
if ( carousels.length > 0 ) {
    let splider;
    loadAsset(`${theme}/assets/js/vendor/splide.min.js?v=${v}`, 'script', () => {
        splider = initSpliders( carousels )
    } );
}

const accordions = document.querySelectorAll('[data-block-accordion]');
if( accordions.length > 0 ) {
    accordions.forEach( accordion => {
        const options = accordion.querySelectorAll('[data-drawer-open]');
        options.forEach( drawer => {
            drawer.addEventListener( 'click', (e)=>{
                e.preventDefault();
                drawer.parentElement.classList.toggle('active');
            } )
        } )
    } )
}

const productCarouselButtons = document.querySelectorAll('[data-product-img-number]');
if ( productCarouselButtons.length > 0 ) {
    const productImages = document.querySelectorAll('[data-product-image]');
    function updateProductImage( id ) {
        const image = document.getElementById(`product-image-${id}`);
        productImages.forEach( img => {  img.classList.remove('active'); } );
        image.classList.add('active');
    }

    productCarouselButtons.forEach( button => {
        button.addEventListener( 'click', (e)=>{
            e.preventDefault();
            const id = button.getAttribute('data-product-img-number');
            updateProductImage( id );
        } )
    } )
}

const scrollPanels = document.querySelectorAll( '[data-horizontal-scroll]' );
if( scrollPanels.length > 0 ) {
    scrollPanels.forEach( container => {
        container.addEventListener("wheel", (evt) => {
            evt.preventDefault();
            container.scrollLeft += evt.deltaY;
        });
    } )
}

const unitInputs = document.querySelectorAll('input[name="unit"]');
if( unitInputs.length > 0 ) {
    let preferredUnits = window.localStorage.getItem('userPreferredUnits') || 'imperial';

    function updateMeasurements( system ) {
        window.localStorage.setItem('userPreferredUnits', system); //set localStorage
        const unit = `data-${system}`;
        const measures = document.querySelectorAll( `[${unit}]` );
        measures.forEach( measure => {
            measure.innerHTML = measure.getAttribute( unit );
        } )
    }

    unitInputs.forEach( input => {
        input.checked = input.value == preferredUnits; //update this input to reflect user pref
        input.addEventListener( 'change', () => {
            updateMeasurements( input.value )
        } )
    } )
 
    updateMeasurements( preferredUnits );

}

const maps = document.querySelectorAll('[data-map]') ;
if( maps.length > 0 ) {
    const key = 'AIzaSyAOVb2gjN6KsUTeVWVDFaFRYRmad3iFf9w'; //production
    // const key = 'AIzaSyAodxoCcVOlhZplpIiku7burNsyaNKwsZo';
    const getLocations = () => {
        fetch(`${theme}/data/map.json`)
            .then(response => response.json())
            .then(data => {  setupMaps(data) })
            .catch(error => console.log(error));
    }
    const setupMaps = (locations) => {
        maps.forEach( map => {
            const thisMap = new window.google.maps.Map(map, {
                center: new google.maps.LatLng(43.0389, -87.9065),
                zoom: 6,
                disableDefaultUI: true,
                scaleControl: true,
                zoomControl: true,
            });
            var mapInfoBubble = new window.google.maps.InfoWindow();
            var bounds = new window.google.maps.LatLngBounds();
            const colors = { 'manufacturing' : '#4cad86', 'hq' : '#00BCAE', 'rpm' : '#48939E', 'service' : '#48939E', 'ncs' : '#02433E', 'sales' : '#046F66' };

            locations.forEach( location => {
                
                var coords = {lat: Number(location['location-latitude']), lng: Number(location['location-longitude'])};
                var marker = new window.google.maps.Marker({
                    position: coords,
                    map: thisMap,
                    icon: {
                        path: google.maps.SymbolPath.CIRCLE,
                        scale: 5,
                        fillColor: colors[ location['location-business-function']['value'] ],
                        strokeColor: colors[ location['location-business-function']['value'] ],
                    },
                    title: location['location-title'],
                });

                // update the map's bounds to show this marker
                bounds.extend(marker.getPosition());
                google.maps.event.addListener(marker, 'click', function() {
                    mapInfoBubble.setContent(`<b style="padding-bottom:.25rem">${location['location-title']}</b><br />${location['location-address']}<br /><a style="color: #046F66; display: block; padding-top: .25rem" href="tel:${location['location-telephone']}">${location['location-telephone']}</a>`);
                    mapInfoBubble.open({anchor: marker, thisMap});
                });
            });

            window.google.maps.event.addListener(map, 'click', function() {
                mapInfoBubble.close();
            });
        } )
    }

    typeof window.google === 'undefined' ? loadAsset(`https://maps.googleapis.com/maps/api/js?libraries=places&key=${key}`, 'script', getLocations) : getLocations;
}